import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const DeviceContainer = styled.main`
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  & > img:last-child {
    margin-top: 40px;
  }
`;

export const DeviceWrapper = styled.div`
  background: ${colors.white};
  box-shadow: 0px 5px 5px 0px ${colors.shadow};
  padding: 10px;
  width: 80%;
  border-radius: 10px;
  text-align: center;
`;

export const DeviceText = styled.div`
  padding: 30px 0;
`;

export const DeviceOptions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 0;

  img {
    width: 256px;
  }
`;

